import { ExportFileField } from './ExportFileTypes';

/**
 * Dato che i campi tornano come stringe in camelCase
 * formatto il campo in modo che sia più leggibile
 * (e.g. "nomeCognomeUtente titolare" -> "Nome Cognome Utente Titolare")
 */
export function camelCaseToWords(str: string) {
  return str
    .match(/(?:\b\w|[A-Z])[^A-Z\W]*/g)
    ?.map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

export function useExportFileFieldSelectOptions(
  fields: ExportFileField[] | null | undefined,
) {
  if (!fields) {
    return [];
  }
  return fields
    .map(field => ({
      value: field.chiave!,
      label: field.titolo ?? camelCaseToWords(field.chiave!) ?? '',
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
